<template>
  <div class="content">
    <b-breadcrumb>
      <b-breadcrumb-item :to="{ name: 'Dashboard' }">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Editar Cotejo</b-breadcrumb-item>
    </b-breadcrumb>

    <!-- Aux -->
    <div class="container">
      <div v-if="loading">
        <div id="loader">
          <font-awesome-icon icon="spinner" spin />
        </div>
      </div>
    </div>

    <!-- Modales -->
    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog-route" hide-footer id="modal-confirm-dialog-route">
      <h4 class="text-center">¿Seguro que quiere salir de la página?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog-route')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="beforeLeave(true)">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere salir sin guardar los cambios?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-validate" hide-footer id="modal-confirm-validate">
      <h4 class="text-center">¿Está seguro de validar? Los datos no podrán ser modificados posteriormente.</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-validate')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="postMethod">OK</b-button>
    </b-modal>

    <!-- Template -->
    <div class="container-fluid">
      <b-row>
        <b-col class="col-3">
          <b-card>
            <TreeEditCotejo user="Staff" :cotejo="cotejo" :selected-component="currentComponentBody" @node="selected" />
          </b-card>
        </b-col>
        <b-col class="col-9">
          <b-card>
            <b-row>
              <b-col class="col-12">
                <div v-if="currentComponentBody === 'ValidaComparecientes'">
                  <ComplementaInformacion :cotejo="cotejo" @submit.prevent @allChecksPassed="validaComparecientesHandler" />
                </div>
                <div v-if="currentComponentBody === 'Domicilio'">
                  <Domicilio :cotejo="cotejo" @submit.prevent @allChecksPassed="domicilioHandler" />
                </div>
                <div v-if="currentComponentBody === 'ValidaCotizacion'">
                  <Cotizacion :cotejo="cotejo" @submit.prevent @allChecksPassed="validaCotizacionHandler" />
                </div>
                <div v-if="currentComponentBody === 'ValidaDocumentos'">
                  <EntregaDocumentos
                    :cotejo="cotejo"
                    @submit.prevent
                    @toggleOnLoadingEvent="toggleOnLoadingHandler"
                    @toggleOffLoadingEvent="toggleOffLoadingHandler"
                    @allChecksPassed="validaDocumentosHandler"
                  />
                </div>
                <div v-if="currentComponentBody === 'Correduria'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form ref="correduria" @submit.prevent="handleSubmit()">
                      <Correduria
                        :cotejo="cotejo"
                        @submit.prevent
                        @allChecksPassed="setModalValidate('Correduria')"
                        @toggleOnLoadingEvent="toggleOnLoadingHandler"
                        @toggleOffLoadingEvent="toggleOffLoadingHandler"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'EntregaDocumentosOriginales'">
                  <EntregaDocumentosOriginales
                    :cotejo="cotejo"
                    @submit.prevent
                    @toggleOnLoadingEvent="toggleOnLoadingHandler"
                    @toggleOffLoadingEvent="toggleOffLoadingHandler"
                    @allChecksPassed="entregaDocumentosOriginalesHandler"
                  />
                </div>
                <div v-if="currentComponentBody === 'RevisionDocumentosOriginales'">
                  <RevisionDocumentosOriginales
                    :cotejo="cotejo"
                    @submit.prevent
                    @toggleOnLoadingEvent="toggleOnLoadingHandler"
                    @toggleOffLoadingEvent="toggleOffLoadingHandler"
                    @allChecksPassed="revisionDocumentosOriginalesHandler"
                  />
                </div>
                <div v-if="currentComponentBody === 'PagoComplementario'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form ref="pagocomplementario" @submit.prevent="handleSubmit()">
                      <PagoComplementario
                        :cotejo="cotejo"
                        @submit.prevent
                        @allChecksPassed="setModalValidate('PagoComplementario')"
                        @pagadoComplementario="setModalValidate('PagadoComplementario')"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'CotejoListo'">
                  <CotejoListo
                    :cotejo="cotejo"
                    @submit.prevent
                    @toggleOnLoadingEvent="toggleOnLoadingHandler"
                    @toggleOffLoadingEvent="toggleOffLoadingHandler"
                    @allChecksPassed="cotejoListoHandler"
                  />
                </div>
                <div v-if="currentComponentBody === 'Actas'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form ref="actas" @submit.prevent="handleSubmit(setModalValidate('Actas'))">
                      <Actas
                        :cotejo="cotejo"
                        @submit.prevent
                        @toggleOnLoadingEvent="toggleOnLoadingHandler"
                        @toggleOffLoadingEvent="toggleOffLoadingHandler"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'Expediente'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form ref="expediente" @submit.prevent="handleSubmit(setModalValidate('Expediente'))">
                      <Expediente :cotejo="cotejo" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'Terminado'">
                  <Terminado :proceso-terminado="cotejo.id_estatus === 21" @terminar-proceso="setModalValidate('Terminado')" />
                </div>
                <!-- <div v-if="currentComponentBody === 'FAD'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form ref="fad" @submit.prevent="handleSubmit()">
                      <FAD
                        :cotejo="cotejo"
                        @submit.prevent
                        @allChecksPassed="setModalValidate('FAD')"
                        @checkFadStatus="setModalValidate('checkFadStatus')"
                        @toggleOnLoadingEvent="toggleOnLoadingHandler"
                        @toggleOffLoadingEvent="toggleOffLoadingHandler"
                      />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'EstatusDocumentos'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form ref="estatusdocumentos" @submit.prevent="handleSubmit(setModalValidate('EstatusDocumentos'))">
                      <EstatusDocumentos :cotejo="cotejo" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div>
                <div v-if="currentComponentBody === 'DocumentosComplementarios'">
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form
                      ref="DocumentosComplementarios"
                      @submit.prevent="handleSubmit(setModalValidate('DocumentosComplementarios'))"
                    >
                      <EntregaDocumentosComplementarios :cotejo="cotejo" @submit.prevent />
                    </form>
                  </ValidationObserver>
                </div> -->
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Actas from "@/views/clients/procesos/cotejo/Actas.vue";
import ComplementaInformacion from "@/views/clients/procesos/cotejo/ComplementaInformacion.vue";
import Correduria from "@/views/clients/procesos/cotejo/Correduria.vue";
import Domicilio from "@/views/clients/procesos/cotejo/Domicilio.vue";
import EntregaDocumentos from "@/views/clients/procesos/cotejo/staff/EntregaDocumentos.vue";
import EntregaDocumentosOriginales from "@/views/clients/procesos/cotejo/staff/EntregaDocumentosOriginales.vue";
import RevisionDocumentosOriginales from "@/views/clients/procesos/cotejo/staff/RevisionDocumentosOriginales.vue";
import CotejoListo from "@/views/clients/procesos/cotejo/staff/CotejoListo.vue";
// import EntregaDocumentosComplementarios from "@/views/clients/procesos/cotejo/EntregaDocumentosComplementarios.vue";
// import EstatusDocumentos from "@/views/clients/procesos/cotejo/EstatusDocumentos.vue";
import Expediente from "@/views/clients/procesos/cotejo/Expediente.vue";
// import FAD from "@/views/clients/procesos/cotejo/FAD.vue";
import PagoComplementario from "@/views/clients/procesos/cotejo/PagoComplementario.vue";
import Terminado from "@/views/clients/procesos/cotejo/Terminado.vue";
import TreeEditCotejo from "@/views/clients/procesos/cotejo/TreeEditCotejo.vue";
import Cotizacion from "@/views/clients/procesos/cotejo/Cotizacion.vue";

import {
  CatDocumentosApi,
  ComparecientesApi,
  CotejosApi,
  CotizacionesApi,
  DocumentosApi,
  DocumentosXServiciosApi,
  DomiciliosApi,
  FuncionesApi,
} from "@/api";
import loadingMixin from "@/mixins/loadingMixin";

export default {
  name: "ValidCotejo",

  components: {
    TreeEditCotejo,
    ComplementaInformacion,
    Domicilio,
    Cotizacion,
    EntregaDocumentos,
    Correduria,
    EntregaDocumentosOriginales,
    RevisionDocumentosOriginales,
    PagoComplementario,
    CotejoListo,
    Actas,
    Expediente,
    Terminado,
    // EntregaDocumentosComplementarios,
    // EstatusDocumentos,
    // FAD,
  },

  mixins: [loadingMixin],

  created() {
    this.loading = true;
    this.cotejo.id = this.$route.params.id;
    this.getCotejo()
      .then(() => this.addSolicitanteFromCompareciente())
      .then(() => this.addRepresentanteIfMoral())
      .then(() => this.fillRepresentante())
      .then(() => this.getCatDocumentosCotejos())
      .then(() => this.getDocumentosXServiciosCotejos())
      .then(() => this.getDocumentosCotejos())
      .then(() => this.addTipoToDocumentos())
      .then(() => this.getDomicilio())
      .then(() => this.getCotizacionComplementaria())
      .then(() => this.getEstatus())
      .catch((error) => {
        this.showErrorToast("Sucedió un error, intente más tarde");
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },

  beforeRouteLeave(to, from, next) {
    if (to.path.includes("editcomparecientes") || to.name === "Editcotejo") {
      return next();
    }

    this.next = next;
    this.$refs["modal-confirm-dialog-route"].show();
  },

  data: () => ({
    next: null,
    prenode: null,
    modalValidateMethod: null,
    currentComponentBody: "ValidaComparecientes",

    cotejo: {
      staff: true,
      estatusDocumentos: null,

      id: null,
      id_estatus: null,
      id_prioridad: null,
      id_cotizaciones: null,
      id_clientes: null,
      id_comparecientes: null,
      pago_complementario: null,
      id_cotizaciones_complementario: null,
      envio_domicilio: null,
      domicilios_id: null,
      corredurias_id: null,
      validaSolicitantes: null,
      validaDomicilio: null,
      validaDocumentos: null,
      id_comparecientes_representante: null,
      referencia: null,

      solicitantes: [],
      documentos: [],
      precio_total: null,
      liga_pago_complementario: null,
      cotizacion: null,
      eligio_llevar_documentos: null,
      ultimo_formulario_guardado_cliente: null,
      ultimo_formulario_guardado_staff: null,

      currentComponentValues: {
        ValidaComparecientes: false,
        Domicilio: false,
        ValidaCotizacion: false,
        ValidaDocumentos: false,
        Correduria: false,
        EntregaDocumentosOriginales: false,
        RevisionDocumentosOriginales: false,
        PagoComplementario: false,
        CotejoListo: false,
        Actas: false,
        Expediente: false,
        Terminado: false,
        DomicilioEntregaOriginales: false,
        FAD: false,
        EstatusDocumentos: false,
        DocumentosComplementarios: false,
      },
    },
  }),

  methods: {
    openValidateModal() {
      this.$refs["modal-confirm-validate"].show();
    },

    hideValidateModal() {
      this.$refs["modal-confirm-validate"].hide();
    },

    beforeLeave(answer) {
      if (answer) {
        this.next();
      }
    },

    selected(node) {
      this.currentComponentBody = node;
    },

    setModalValidate(postMethod) {
      this.modalValidateMethod = postMethod;

      if (["PagoComplementario", "PagadoComplementario", "FAD", "checkFadStatus", "Expediente"].includes(postMethod)) {
        this.postMethod();
      } else if (postMethod == "Realizacion") {
        this.openSendMailModal();
      } else {
        this.openValidateModal();
      }
    },

    showErrorToast(msg) {
      this.$toast.error(msg, {
        timeout: 4000,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    showSuccessMessage(message, timeout = 4000) {
      this.$toast.success(message, {
        timeout: timeout,
        hideProgressBar: false,
        position: "top-right",
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: "button",
        icon: true,
      });
    },

    validatePastComponentValues(destiny) {
      for (const key in this.cotejo.currentComponentValues) {
        if (key === destiny) {
          this.currentComponentBody = destiny;
          break;
        }

        this.cotejo.currentComponentValues[key] = true;
      }
    },

    changeCurrentComponentValue(origin, destiny) {
      this.cotejo.currentComponentValues[origin] = true;
      this.currentComponentBody = destiny;
    },

    changeCurrentComponentBody(body) {
      this.cotejo.currentComponentValues[this.currentComponentBody] = true;
      this.currentComponentBody = body;
    },

    submitForm(formToSubmit) {
      this.$refs[formToSubmit].dispatchEvent(new Event("submit"));
    },

    async getCotejo() {
      this.cotejo = {
        ...this.cotejo,
        ...(await CotejosApi.detail(this.cotejo.id)),
      };
    },

    async addSolicitanteFromCompareciente() {
      const compareciente = await ComparecientesApi.detail(this.cotejo.id_comparecientes);
      this.cotejo.solicitantes.push(compareciente);
    },

    async addRepresentanteIfMoral() {
      if (this.cotejo.id_comparecientes_representante) {
        const representante = await ComparecientesApi.detail(this.cotejo.id_comparecientes_representante);
        this.cotejo.solicitantes.push(representante);
      }
    },

    async fillRepresentante() {
      this.cotejo.solicitantes.forEach((solicitante) => {
        if (solicitante.moral_representada_id) {
          solicitante.representante = `✓`;
        }
      });
    },

    async getCatDocumentosCotejos() {
      const { value } = await CatDocumentosApi.list({
        page: 0,
        registersPerPage: 0,
        categoria: "cotejos",
      });
      this.catDocumentos = value;
    },

    async getDocumentosXServiciosCotejos() {
      const { value } = await DocumentosXServiciosApi.list({
        page: 0,
        registersPerPage: 0,
        cat_servicios_id: 4,
        id_proceso: this.cotejo.id,
      });
      this.documentosXServicios = value;
    },

    async getDocumentosCotejos() {
      this.cotejo.documentos = await Promise.all(
        this.documentosXServicios.map((documentoXServicio) => this.getDocumentoDetail(documentoXServicio.documentos_id)),
      );
    },

    async getDocumentoDetail(id) {
      return DocumentosApi.detail(id);
    },

    async addTipoToDocumentos() {
      this.cotejo.documentos = await Promise.all(
        this.cotejo.documentos.map(async (documento) => {
          documento.tipo = this.getCatDocumentoNombreById(documento.cat_documentos_id);
          return documento;
        }),
      );
    },

    getCatDocumentoNombreById(cat_documentos_id) {
      const catDocumento = this.catDocumentos.find((doc) => doc.id == cat_documentos_id);
      return catDocumento ? catDocumento.documento : null;
    },

    async getDomicilio() {
      this.cotejo.domicilio = await DomiciliosApi.detail(this.cotejo.domicilios_id);
    },

    async getCotizacionComplementaria() {
      if (!this.cotejo.id_cotizaciones_complementario) {
        return;
      }

      const { liga_pago } = await CotizacionesApi.detail(this.cotejo.id_cotizaciones_complementario);
      this.cotejo.liga_pago_complementario = liga_pago;
    },

    getEstatus() {
      if (!this.cotejo.ultimo_formulario_guardado_staff) {
        this.currentComponentBody = "ValidaComparecientes";
      }

      if (this.cotejo.ultimo_formulario_guardado_staff === "ValidaComparecientes") {
        let currentComponentBody = "Domicilio";

        if (!this.cotejo.envio_domicilio) {
          currentComponentBody = "ValidaCotizacion";
        }

        this.validatePastComponentValues(currentComponentBody);
      }
      if (this.cotejo.ultimo_formulario_guardado_staff === "Domicilio") {
        this.validatePastComponentValues("ValidaCotizacion");
      }
      if (this.cotejo.ultimo_formulario_guardado_staff === "ValidaCotizacion") {
        this.validatePastComponentValues("ValidaDocumentos");
      }
      if (this.cotejo.ultimo_formulario_guardado_staff === "ValidaDocumentos") {
        this.validatePastComponentValues("Correduria");
      }
      if (this.cotejo.ultimo_formulario_guardado_staff === "Correduria") {
        this.validatePastComponentValues("EntregaDocumentosOriginales");
      }
      if (this.cotejo.ultimo_formulario_guardado_staff === "EntregaDocumentosOriginales") {
        this.validatePastComponentValues("RevisionDocumentosOriginales");
      }
      if (this.cotejo.ultimo_formulario_guardado_staff === "RevisionDocumentosOriginales") {
        this.validatePastComponentValues("PagoComplementario");
      }
      if (this.cotejo.ultimo_formulario_guardado_staff === "PagoComplementario") {
        this.validatePastComponentValues("CotejoListo");
      }
      if (this.cotejo.ultimo_formulario_guardado_staff === "CotejoListo") {
        this.validatePastComponentValues("Actas");
      }
      if (this.cotejo.ultimo_formulario_guardado_staff === "Actas") {
        this.validatePastComponentValues("Expediente");
      }
      if (this.cotejo.ultimo_formulario_guardado_staff === "Expediente") {
        this.validatePastComponentValues("Terminado");
      }

      // return;

      // this.changeCurrentComponentBody("ValidaComparecientes");

      // if (this.cotejo.validaSolicitantes == 1) {
      //   this.changeCurrentComponentValue("ValidaComparecientes", "ValidaDocumentos");
      // }

      // if (this.cotejo.validaDocumentos == 1) {
      //   if (!this.cotejo.envio_domicilio) {
      //     this.changeCurrentComponentValue("ValidaDocumentos", "EstatusDocumentos");
      //   } else {
      //     this.changeCurrentComponentValue("ValidaDocumentos", "Domicilio");
      //     if (this.cotejo.validaDomicilio == 1) {
      //       this.changeCurrentComponentValue("Domicilio", "EstatusDocumentos");
      //     }
      //   }
      // }

      // if (this.cotejo.pago_complementario) {
      //   this.cotejo.estatusDocumentos = "pago";
      // }

      // if ([18, 19, 20, 21, 74, 75, 76].includes(this.cotejo.id_estatus)) {
      //   this.changeCurrentComponentValue("EstatusDocumentos", "PagoComplementario");
      // }
      // if ([19, 20, 21, 74, 75, 76].includes(this.cotejo.id_estatus)) {
      //   this.cotejo.estatusDocumentos = "ok";
      //   this.changeCurrentComponentValue("PagoComplementario", "FAD");
      // }
      // if ([19, 20, 21, 75].includes(this.cotejo.id_estatus)) {
      //   this.changeCurrentComponentValue("FAD", "Actas");
      // }
      // if ([20, 21].includes(this.cotejo.id_estatus)) {
      //   this.changeCurrentComponentValue("Actas", "Expediente");
      // }
      // if (this.cotejo.id_estatus == 21) {
      //   this.changeCurrentComponentValue("Expediente", "Terminado");
      // }
    },

    async validaComparecientesHandler() {
      try {
        this.loading = true;

        await this.actualizaCompareciente();
        await this.actualizaRepresentante();
        this.cotejo.validaSolicitantes = 1;
        this.cotejo.ultimo_formulario_guardado_staff = "ValidaComparecientes";
        if (!(await this.actualizaCotejo())) {
          return;
        }

        this.showSuccessMessage("Información guardada.", 2000);

        let currentComponentBody = "Domicilio";
        if (!this.cotejo.envio_domicilio) {
          currentComponentBody = "ValidaCotizacion";
        }

        this.validatePastComponentValues(currentComponentBody);
      } catch (error) {
        console.log(error);
        this.showErrorToast("Sucedió un error al procesar la información, intente más tarde");
      } finally {
        this.loading = false;
      }
    },

    async domicilioHandler() {
      try {
        this.loading = true;

        await this.actualizaDomicilio();
        this.cotejo.validaDomicilio = 1;
        this.cotejo.ultimo_formulario_guardado_staff = "Domicilio";
        if (!(await this.actualizaCotejo())) {
          return;
        }

        this.showSuccessMessage("Información guardada.", 2000);
        this.validatePastComponentValues("ValidaCotizacion");
      } catch (error) {
        console.log(error);
        this.showErrorToast("Sucedió un error al procesar la información, intente más tarde");
      } finally {
        this.loading = false;
      }
    },

    async validaCotizacionHandler() {
      try {
        this.loading = true;

        this.cotejo.ultimo_formulario_guardado_staff = "ValidaCotizacion";
        if (!(await this.actualizaCotejo())) {
          return;
        }

        this.showSuccessMessage("Información guardada.", 2000);
        this.validatePastComponentValues("ValidaDocumentos");
      } catch (error) {
        console.log(error);
        this.showErrorToast("Sucedió un error al procesar la información, intente más tarde");
      } finally {
        this.loading = false;
      }
    },

    async validaDocumentosHandler() {
      try {
        this.loading = true;

        this.cotejo.ultimo_formulario_guardado_staff = "ValidaDocumentos";
        this.cotejo.validaDocumentos = 1;
        if (!(await this.actualizaCotejo())) {
          return;
        }

        this.showSuccessMessage("Información guardada.", 2000);
        this.validatePastComponentValues("Correduria");
      } catch (error) {
        console.log(error);
        this.showErrorToast("Sucedió un error al procesar la información, intente más tarde");
      } finally {
        this.loading = false;
      }
    },

    async correduriaHandler() {
      this.cotejo.ultimo_formulario_guardado_staff = "Correduria";
      if (!(await this.actualizaCotejo())) {
        return;
      }

      this.showSuccessMessage("Información guardada.", 2000);
      this.validatePastComponentValues("EntregaDocumentosOriginales");
    },

    async entregaDocumentosOriginalesHandler() {
      try {
        this.loading = true;

        this.cotejo.ultimo_formulario_guardado_staff = "EntregaDocumentosOriginales";
        // this.cotejo.validaDocumentos = 1;
        if (!(await this.actualizaCotejo())) {
          return;
        }

        this.showSuccessMessage("Información guardada.", 2000);
        this.validatePastComponentValues("RevisionDocumentosOriginales");
      } catch (error) {
        console.log(error);
        this.showErrorToast("Sucedió un error al procesar la información, intente más tarde");
      } finally {
        this.loading = false;
      }
    },

    async revisionDocumentosOriginalesHandler() {
      try {
        this.loading = true;

        this.cotejo.ultimo_formulario_guardado_staff = "RevisionDocumentosOriginales";
        // this.cotejo.validaDocumentos = 1;
        if (!(await this.actualizaCotejo())) {
          return;
        }

        this.showSuccessMessage("Información guardada.", 2000);
        this.validatePastComponentValues("PagoComplementario");
      } catch (error) {
        console.log(error);
        this.showErrorToast("Sucedió un error al procesar la información, intente más tarde");
      } finally {
        this.loading = false;
      }
    },

    async cotejoListoHandler() {
      try {
        this.loading = true;

        this.cotejo.ultimo_formulario_guardado_staff = "CotejoListo";
        // this.cotejo.validaDocumentos = 1;
        if (!(await this.actualizaCotejo())) {
          return;
        }

        this.showSuccessMessage("Información guardada.", 2000);
        this.validatePastComponentValues("Actas");
      } catch (error) {
        console.log(error);
        this.showErrorToast("Sucedió un error al procesar la información, intente más tarde");
      } finally {
        this.loading = false;
      }
    },

    async procesoTerminadoHandler() {
      try {
        this.loading = true;

        this.cotejo.ultimo_formulario_guardado_staff = "Terminado";
        this.cotejo.id_estatus = 21;

        if (!(await this.actualizaCotejo())) {
          return;
        }

        this.showSuccessMessage("Proceso terminado.", 2000);
        this.cotejo.currentComponentValues.Terminado = true;
      } catch (error) {
        console.log(error);
        this.showErrorToast("Sucedió un error al procesar la información, intente más tarde");
      } finally {
        this.loading = false;
      }
    },

    postMethod() {
      this.hideValidateModal();

      switch (this.modalValidateMethod) {
        case "Correduria":
          this.correduriaHandler();
          break;
        case "EstatusDocumentos":
          if (!this.cotejo.estatusDocumentos) {
            this.showErrorToast("Por favor ingresa la información solicitada.");
            break;
          }
          let destinyComponent = "";
          if (this.cotejo.estatusDocumentos == "ok") {
            this.cotejo.id_estatus = 74;
            destinyComponent = "FAD";
          } else if (this.cotejo.estatusDocumentos == "pago") {
            this.cotejo.id_estatus = 18;
            this.cotejo.pago_complementario = 1;
            destinyComponent = "PagoComplementario";
          } else if (this.cotejo.estatusDocumentos == "no ok") {
            this.showErrorToast("Por favor contacte al cliente.");
            break;
          }
          this.actualizaCotejo();
          this.changeCurrentComponentValue("EstatusDocumentos", destinyComponent);
          break;
        case "PagoComplementario":
          this.actualizaCotejo();
          break;
        case "PagadoComplementario":
          this.cotejo.id_estatus = 74;
          this.changeCurrentComponentValue("PagoComplementario", "FAD");
          this.actualizaCotejo();
          break;
        case "FAD":
          this.cotejo.id_estatus = 76;
          this.actualizaCotejo();
          break;
        case "checkFadStatus":
          this.loading = true;
          this.checkFad()
            .then(() => this.getCotejo())
            .then(() => {
              if (this.isFadSigned()) {
                this.changeCurrentComponentValue("FAD", "Actas");
              } else {
                this.showErrorToast("El cliente no ha firmado el documento. Intente más tarde.");
              }
            })
            .catch((error) => {
              console.log(error);
              this.showErrorToast("Hubo un error al checar el estatus de FAD. Intente más tarde.");
            })
            .finally(() => {
              this.loading = false;
            });
          break;
        case "Actas":
          this.cotejo.id_estatus = 20;
          this.actualizaCotejo();
          this.changeCurrentComponentValue("Actas", "Expediente");
          break;
        case "Expediente":
          this.changeCurrentComponentValue("Expediente", "Terminado");
          break;
        case "Terminado":
          this.procesoTerminadoHandler();
          break;
      }
    },

    async actualizaDomicilio() {
      return await DomiciliosApi.edit(this.cotejo.domicilios_id, {
        calle: this.cotejo.domicilio.calle,
        num_exterior: this.cotejo.domicilio.num_exterior,
        num_interior: this.cotejo.domicilio.num_interior,
        colonia: this.cotejo.domicilio.colonia,
        delegacion_municipio: this.cotejo.domicilio.delegacion_municipio,
        ciudad: this.cotejo.domicilio.ciudad,
        entidad: this.cotejo.domicilio.entidad,
        pais: this.cotejo.domicilio.pais,
        codigo_postal: this.cotejo.domicilio.codigo_postal,
        extranjero: 0,
        tipo: "Personal",
        tieneExtranjero: null,
        tieneTipo: null,
        lat: this.cotejo.domicilio.lat,
        lng: this.cotejo.domicilio.lng,
        valido: 1,
        comentario: null,
        validador: null,
        activo: 1,
      });
    },

    async actualizaCotejo() {
      try {
        this.loading = true;
        await CotejosApi.edit(this.cotejo.id, this.cotejo);
        return true;
      } catch (error) {
        console.log(error);
        this.showErrorToast("No se pudo actualizar la información. Intente más tarde.");
        return false;
      } finally {
        this.loading = false;
      }
    },

    async actualizaCompareciente() {
      let compareciente = this.cotejo.solicitantes.length == 1 ? this.cotejo.solicitantes[0] : null;

      if (!compareciente) {
        compareciente = this.cotejo.solicitantes.find((solicitante) => solicitante.persona == "Moral");
      }

      compareciente.tipo_validacion = compareciente.persona == "Moral" ? "new_constitucion_pm" : "new_constitucion_pf";

      if (compareciente.hasOwnProperty("telefono") && compareciente.telefono != {}) {
        const index = compareciente.telefonos.findIndex((telefono) => telefono.id === compareciente.telefono.id);
        compareciente.telefonos[index] = compareciente.telefono;
      }

      compareciente.completado = true;
      compareciente.cat_servicio_id = 4;
      compareciente.servicio_id = this.cotejo.id;

      return await ComparecientesApi.edit(compareciente.id, compareciente);
    },

    async actualizaRepresentante() {
      if (this.cotejo.solicitantes.length == 1) {
        return;
      }
      const representante = this.cotejo.solicitantes.find((solicitante) => solicitante.persona == "Física");
      representante.tipo_validacion = "new_constitucion_pf";
      return await ComparecientesApi.edit(representante.id, representante);
    },

    async checkFad() {
      await FuncionesApi.checkFadKycsEstatus({
        proceso_id: this.cotejo.id,
        cat_servicios_id: 4,
      });
    },

    isFadSigned() {
      if (parseInt(this.cotejo.estatus_id) === 75) {
        return true;
      }
      return false;
    },
  },
};
</script>
